import React from 'react'
import { I18n } from 'react-redux-i18n'
import { USER_STATES } from '../../../constants'
import SelectWithLabel from '../SelectWithLabel'

// eslint-disable-next-line react/display-name
export default ({ allowEmpty = true, allStates = false, name = 'state', value, isDisabled, ...rest }) => {
  const type = allStates ? 'all' : 'top'

  let options = USER_STATES[type].map((state) => ({
    value: state,
    label: I18n.t(`states_${state}`),
  }))

  const optionsWithNauta = USER_STATES['nauta'].map((state) => ({
    value: state,
    label: I18n.t(`states_${state}`),
  })).concat(options)

  if (allowEmpty) options = [{ value: '', label: I18n.t('dashboard_selector_select-state') }, ...options]

  return (
    // <Select
    //   onChange={({ value }) => rest.onChange({ target: { value, name: 'state' } })}
    //   value={optionsWithNauta.find((o) => o.value === value)}
    //   options={options}
    //   styles={STYLES_REACT_SELECT}
    // />
    <SelectWithLabel
      classNameWrapper='select-states'
      // options={filters.roles.map((elem) => ({ value: elem, label: I18n.t(`roles_${elem}`) }))}
      options={options}
      value={optionsWithNauta.find((o) => o.value === value)}
      onChange={({ value }) => rest.onChange({ target: { value, name: 'state' } })}
      isDisabled={isDisabled}
    />
  )
}
